import { OddsFormat } from '@app/types'

function gcd(a: number, b: number): number {
  return b === 0 ? a : gcd(b, a % b)
}

export function toFractional(decimal: number): string {
  // Express (decimal - 1) as a fraction with denominator up to 100
  const numeratorFloat = decimal - 1
  const denominator = 100
  const numeratorInt = Math.round(numeratorFloat * denominator)
  const divisor = gcd(Math.abs(numeratorInt), denominator)
  return `${numeratorInt / divisor}/${denominator / divisor}`
}

export function toAmerican(decimal: number): string {
  if (decimal >= 2) {
    return `+${Math.round((decimal - 1) * 100)}`
  }
  return `${Math.round(-100 / (decimal - 1))}`
}

export function formatOdds(decimal: number | null | undefined, format: OddsFormat): string {
  if (decimal == null) return '-'
  switch (format) {
    case OddsFormat.Fractional:
      return toFractional(decimal)
    case OddsFormat.American:
      return toAmerican(decimal)
    default:
      return Number(decimal).toFixed(2)
  }
}

export const ODDS_FORMAT_EXAMPLES: Record<OddsFormat, string> = {
  [OddsFormat.Decimal]: '2.50',
  [OddsFormat.Fractional]: '3/2',
  [OddsFormat.American]: '+150',
}

export const ODDS_FORMAT_LABELS: Record<OddsFormat, string> = {
  [OddsFormat.Decimal]: 'oddsFormat.decimal',
  [OddsFormat.Fractional]: 'oddsFormat.fractional',
  [OddsFormat.American]: 'oddsFormat.american',
}
